export default __webpack_public_path__ + "static/panoroom_unique_measurement-372ddc082a02011193e07dfeb5346605.mp4";